module.exports = __webpack_public_path__ + "static/media/rabab-player.a87def65.png";